
(function (window, document, jQuery, undefined) {

    var $ = jQuery.noConflict();
    var $cards = $(".personio-job-card:not(.personio-job-card--no-detail)");

    $(document).ready(function () { 
        $cards.hover(
            function () {
                $(this).addClass('shadow');
            }, function () {
                $(this).removeClass('shadow');
            }
        );
    });

})(window, document, jQuery);
